import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/cbc-logo-full.png")